// action types
export var API_REQUEST = 'API_REQUEST';
export var API_SUCCESS = 'API_SUCCESS';
export var API_ERROR = 'API_ERROR'; // action creators

export var apiRequest = function apiRequest(_ref) {
  var body = _ref.body,
      method = _ref.method,
      url = _ref.url,
      feature = _ref.feature;
  return {
    type: "".concat(feature, " ").concat(API_REQUEST),
    payload: body,
    meta: {
      method: method,
      url: url,
      feature: feature
    }
  };
};
export var apiSuccess = function apiSuccess(_ref2) {
  var response = _ref2.response,
      feature = _ref2.feature;
  return {
    type: "".concat(feature, " ").concat(API_SUCCESS),
    payload: response,
    meta: {
      feature: feature
    }
  };
};
export var apiError = function apiError(_ref3) {
  var error = _ref3.error,
      response = _ref3.response,
      feature = _ref3.feature;
  return {
    type: "".concat(feature, " ").concat(API_ERROR),
    payload: {
      error: error,
      response: response
    },
    meta: {
      feature: feature
    }
  };
};